app.service('blogService', function ($http) {

  this.getBlogPost = function (obj) {
    return $http.post('/blog/getBlogPost', obj)
      .then(function (response) {
        return response
      })
  }

  this.getBlogPosts = function (obj) {
    return $http.post('/blog/getBlogPosts', obj)
      .then(function (response) {
        return response
      })
  }

  // this.updatePostRead = function (obj) {
  //   return $http.post('/blog/updatePostRead', obj)
  //     .then(function (response) {
  //       return response
  //     })
  // }

  this.updatePostLike = function (obj) {
    return $http.post('/blog/updatePostLike', obj)
      .then(function (response) {
        return response
      })
  }

})